import { KNOWLEDGE_SHOW_KEYWORDS_VIEW } from '.';

export const knowledgeShowKeywords = id => dispatch => {
  dispatch({
    type: KNOWLEDGE_SHOW_KEYWORDS_VIEW,
    payload: { id },
  });
};
